<div class="search-params-wrapper" [class.logistics-search-params]="inputParams.logisticsMode">
    @for (searchTag of displayTags; track $index) {
    @if (shouldDisplayTag(searchTag)) {
    <span class="search-param-pill-base position-relative" [ngClass]="{'highlighted-badge': searchTag.param === 'selectedTerritory', 'savedSearch-badge': searchTag.param === 'savedSearchName'}" [matTooltip]="inputParams.logisticsMode ? logisticsTooltip(searchTag) : truncParamsTooltips[searchTag.param]" [matTooltipClass]="inputParams.logisticsMode ? 'logistics-search-pill-tooltip' : 'search-pill-tt'">
        <span *ngIf="searchTag.value == 'true'"><i class="fal fa-check-circle"></i> </span>
        <span class="search-param-pill__label" style="font-weight: 500"> {{ displayParamName(searchTag) }}</span>
        <span class="search-param-pill__value" *ngIf="searchTag.value !== 'true' && searchTag.param !== 'selectedCustomColumns'" [ngClass]="{'text-grey-0': searchTag.param !== 'savedSearchName'}">:
            @if (searchTag.param === 'selectedTerritory') {
                {{ searchTag.value | nameOnlyDisplay }}
            } 
            @else {
                {{ formatParamValue({paramObj: searchTag, truncate: !inputParams.logisticsMode}) }}
            }
        </span>
        <span *ngIf="searchTag.param == 'selectedCustomColumns'" class="text-grey-00 search-param-pill__value">:
            {{formatParamValue({paramObj: searchTag})}}       
        </span>
        <span *ngIf="shouldShowLabelsCount(searchTag.param) && labelsCount[searchTag.param] > 1" class="custom-col-counter">{{labelsCount[searchTag.param]}}</span>
        <span *ngIf="inputParams.enableClearing && excludeClearing(searchTag.param)" (click)="clearParameterButtonWasClicked(searchTag)" class="cursor-pointer badge-close-button"><i class="fas fa-times"></i></span>
    </span>
    }
}
</div>
